import moment, { Moment, MomentFormatSpecification } from 'moment';
import get from 'lodash/get';

class DateHelper {
  private static instance: DateHelper;
  public static getInstance(): DateHelper {
    if (!DateHelper.instance) {
      DateHelper.instance = new DateHelper();
    }
    return DateHelper.instance;
  }

  public formatDate(
    date: string | Date,
    format = 'DD/MM/YYYY',
    defaultEmpty = ''
  ): string {
    if (!date) return defaultEmpty;
    const momentDate = moment(date);
    if (!momentDate.isValid()) return '';
    return momentDate.format(format);
  }

  public formatRangeDateByKeys(
    value: any,
    dataIndex: string[],
    options: {
      format?: string;
      defaultEmpty?: string;
    } = {
      format: 'DD/MM/YYYY',
      defaultEmpty: ''
    }
  ) {
    if (!value) return options.defaultEmpty;
    const date = dataIndex
      .map((item) => get(value, item))
      .map((dataValue) => {
        return this.formatDate(dataValue, options.format, options.defaultEmpty);
      })
      .join(' - ');
    return date;
  }
}
export default DateHelper.getInstance();
